import { Builder } from '@builder.io/react';
import styled from '@emotion/styled';
import { Colors, Shadows } from '@zapier/design-system';
import dynamic from 'next/dynamic';

export interface SignUpFormProps {
  hideFieldsUntilFocus?: boolean;
  facebookSSOEnabled?: boolean;
  googleSSOEnabled?: boolean;
  microsoftSSOEnabled?: boolean;
}

const ZapierSignUpForm = dynamic<
  SignUpFormProps & { googleCaptchaSiteKey: string; googleClientId: string }
>(() => import('@zapier/authentication').then((mod) => mod.SignUpForm));

export function SignUpForm({
  hideFieldsUntilFocus = true,
  facebookSSOEnabled = true,
  googleSSOEnabled = true,
  microsoftSSOEnabled = true,
}: SignUpFormProps) {
  return (
    <SignUpFormContainer>
      {Builder.isEditing ? (
        <SignUpFormPlaceholder>Sign up form</SignUpFormPlaceholder>
      ) : (
        <ZapierSignUpForm
          facebookSSOEnabled={facebookSSOEnabled}
          googleCaptchaSiteKey={
            process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_SITE_KEY || ''
          }
          googleClientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || ''}
          googleSSOEnabled={googleSSOEnabled}
          hideFieldsUntilFocus={hideFieldsUntilFocus}
          microsoftSSOEnabled={microsoftSSOEnabled}
        />
      )}
    </SignUpFormContainer>
  );
}

const SignUpFormContainer = styled.div`
  max-width: 370px;
  margin: 0 auto;
  padding: 25px 20px;
  border-radius: 20px;
  background-color: ${Colors.white};
  box-shadow: ${Shadows.elevation5};
`;

const SignUpFormPlaceholder = styled.div`
  width: 375px;
  height: 455px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.gray60};
`;
